import { KpiDataId, MetricData, MetricIdEnum, TimeSeriesDataPoint } from "../Metrics.model";
import { UtilizationMetricsResponse } from "./Utilization.model";

const UTILIZATION_METRIC_META: Record<string, { label: string; description: string }> = {
  [MetricIdEnum.avgStationUtilization]: {
    label: 'Avg. Utilization',
    description: 'This metric represents the average usage or occupancy of charging stations over a given period. It indicates the proportion of time that a charging station is actively in use, providing insights into its efficiency and demand.',
  },
  [MetricIdEnum.timeBasedUtilization]: {
    label: 'Time Based Utilization',
    description: 'Average utilization across selected location and period',
  },
};

export const transformUtilizationResponseToMetricData = (
  response: UtilizationMetricsResponse,
  metricId: MetricIdEnum = MetricIdEnum.timeBasedUtilization,
): MetricData => {
  const meta = UTILIZATION_METRIC_META[metricId] ?? UTILIZATION_METRIC_META[MetricIdEnum.timeBasedUtilization];

  if (metricId === MetricIdEnum.avgStationUtilization) {
    const utilizationPct = response.locationsUtilizationTotal.utilizationPercentage ?? 0;

    return {
      label: meta.label,
      description: meta.description,
      kpi: [
        {
          id: KpiDataId.TOTAL_CURRENT,
          value: Number.parseFloat(utilizationPct.toFixed(2)),
          unit: '%' as any,
          label: 'Utilization',
        },
      ],
      breakdown: { values: [], unit: '%' as any, label: '' },
    };
  }

  const breakdownValues: TimeSeriesDataPoint[] = response.locationsUtilization
    .slice()
    .sort((a, b) => a.aggregationDate.localeCompare(b.aggregationDate))
    .map((entry) => {
      const [, month, day] = entry.aggregationDate.split('-');
      return {
        label: `${day}/${month}`,
        value: Number.parseFloat(entry.utilizationPercentage.toFixed(2)),
      };
    });

  return {
    label: meta.label,
    description: meta.description,
    kpi: [],
    breakdown: {
      values: breakdownValues,
      unit: '%' as any,
      label: 'Utilization Over Time',
    },
  };
}